import React from "react";
import { Form, Row, Col, Divider, Typography, Select, Input, InputNumber } from "antd";

import { getTipoCambioActual } from "../services";

const { Title } = Typography;
const { Option } = Select;

const PagosProductosSection = () => {

    const form = Form.useFormInstance();

    const handleSelectTipoCambio = async (value) => {
        if(value === "USD"){
            let TipoCambio = await getTipoCambioActual()
            form.setFieldsValue({ TipoCambio })
        } else {
            // Si se selecciona MXN, se deshabilita el campo de Tipo de Cambio y se limpia su valor
            form.setFieldsValue({ TipoCambio: 1 });
        }
    }


    return (
        <>
            <Row>
                <Divider orientation="left" style={{ margin: "12px 0 24px 0 " }} />
                <Title level={5}>Información de Pagos y Productos</Title>
            </Row>
            <Row className="mb-3" gutter={[16, 16]}>
                <Col xs={20} md={6}>
                    <Form.Item name="Moneda" label="Moneda">
                        <Select onSelect={handleSelectTipoCambio}>
                            <Option value="MXN">MXN</Option>
                            <Option value="USD">USD</Option>
                        </Select>
                    </Form.Item>
                </Col>
                <Col xs={20} md={6}>
                    <Form.Item name="TipoCambio" label="Tipo de Cambio">
                        <InputNumber
                            style={{ width: "100%" }}
                            formatter={(value) => `$ ${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")}
                            parser={(value) => value && value.replace(/\$\s?|(,*)/g, "")}
                        />
                    </Form.Item>
                </Col>
                <Col xs={24}>
                    <Form.Item
                        label="Observaciones"
                        name="observaciones"
                        rules={[
                            {
                                max: 1000,
                                message: "Máximo de caracteres alcanzado (1000)",
                            },
                        ]}
                    >
                        <Input.TextArea />
                    </Form.Item>
                </Col>
            </Row>
        </>
    );
};

export default PagosProductosSection;
